import React from "react";
import { Col, Row } from "antd";

import { Routes, Route } from "react-router-dom";
import "../../assets/css/zones.css";
import InvoicesPage from "../Invoices";
import PublicPlansList from "./Plans/MyPublicPlansPage";
import PublicPlanCheckout from "./Plans/Checkout";

export default function Public() {
  return (
    <Row align="middle">
      <Col span={24}>
        <Routes>
          <Route
            path="/invoices/:uuid"
            element={<InvoicesPage action="view" />}
          />
          <Route path="/plans/:accountUuid" element={<PublicPlansList />} />
          <Route
            path="/plans/:accountUuid/checkout/:planUuid"
            element={<PublicPlanCheckout />}
          />
        </Routes>
      </Col>
    </Row>
  );
}
